import React from 'react'
import LargeContainer from '../../../UI/Container/LargeContainer'
import HeadlineSplit from '../../../UI/Headline/Split'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import { Kostenstelle } from '../../../../types/Controlling/Kostenstelle'
import SimpleList from '../../../UI/SimpleList/SimpleList'
import Item from './Item'
import Upsert from './Upsert/Upsert'
import useLoadControllingCompany from '../../../hooks/Controlling/useLoadControllingCompany'
import { useParams } from 'react-router-dom'
import useLoadControllingKostenstellen from '../../../hooks/Controlling/useLoadControllingKostenstellen'

const KostenstelleList: React.FC = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const { companyUUID } = useParams()
  const company = useLoadControllingCompany(companyUUID)
  const [kostenstellen, pull] = useLoadControllingKostenstellen()

  const filter = (search: string) => (item: Kostenstelle) => {
    return item.name.toLowerCase().includes(search.toLowerCase())
  }

  if (!company) return <></>
  return (
    <LargeContainer>
      <div className="flex flex-col gap-1 pt-2 pb-10 mt-10">
        <HeadlineSplit prefix={`${company.name} - `} suffix={t.controlling.kostenstelle.list.titleSplit.suffix} />
        <SimpleList enableBlockView data={kostenstellen} filter={filter} Component={Item} pull={pull} Upsert={Upsert} />
      </div>
    </LargeContainer>
  )
}

export default KostenstelleList
